import _ from 'lodash';
import React from 'react';

import Table from 'components/Table';
import Money from 'components/Money';
import Button from 'components/Button';
import StatusBox from 'components/StatusBox';
import BooleanIcon from 'components/BooleanIcon';

import {EmptyListPlaceholder} from 'containers/BookingSetDetail/components';

import {humanReadableBoolean} from 'utils/common';

import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

import './styles.css';

interface RoomChecksProps {
  roomNumber: string;
  roomType: string;
  totalDamageCharge: number;
  status: string;
  description: string;
  hasImages: boolean;
  hasInventory: boolean;
  hasMaintenance: boolean;
  chargeFromDeposit: boolean;
  invoiceReceivedAtFrontDesk: any;
}

interface DepartureRoomChecksTableProps {
  roomChecks: Array<RoomChecksProps>;
  disableAddButton: boolean;
  openAddDepartureRoomCheckModal: () => any;
  openDepartureRoomCheckDetailModal: ({roomCheckId: number}) => any;
  openInvoiceDetailModal: any;
}

const STATUS_TO_COLOR_MAPPER = {
  Pending: StatusBox.ORANGE,
  Completed: StatusBox.GREEN
};

const RoomCheckRow = ({
  roomCheck,
  openDepartureRoomCheckDetailModal,
  openInvoiceDetailModal
}) => (
  <Table.Row
    onClick={() =>
      openDepartureRoomCheckDetailModal({roomCheckId: roomCheck.id})
    }>
    <Table.Cell className="room">
      <div>{roomCheck.roomNumber}</div>
    </Table.Cell>
    <Table.Cell className="roomType">
      <div>{roomCheck.roomType}</div>
    </Table.Cell>
    <Table.Cell className="inventory">
      <BooleanIcon value={roomCheck.hasInventory} />
    </Table.Cell>
    <Table.Cell className="maintenance">
      <BooleanIcon value={roomCheck.hasMaintenance} />
    </Table.Cell>
    <Table.Cell className="images">
      <BooleanIcon value={roomCheck.hasImages} />
    </Table.Cell>
    <Table.Cell className="totalDamageCharge">
      <div>
        <Money balance amount={roomCheck.totalDamageCharge} />
      </div>
    </Table.Cell>
    <Table.Cell className="frontDeskCharge">
      {roomCheck.invoiceReceivedAtFrontDesk && (
        <ClickIconWithNoPropagation
          onClick={() =>
            openInvoiceDetailModal(
              roomCheck.invoiceReceivedAtFrontDesk.scheduleType,
              roomCheck.invoiceReceivedAtFrontDesk.id,
              roomCheck.invoiceReceivedAtFrontDesk.tenancyId
            )
          }>
          <div className="colab-clickable colab-link">
            {roomCheck.invoiceReceivedAtFrontDesk.amountReceivedAtFrontDesk}
          </div>
        </ClickIconWithNoPropagation>
      )}
      {!roomCheck.invoiceReceivedAtFrontDesk && 'N/A'}
    </Table.Cell>
    <Table.Cell className="toBeRetainedFromDeposit">
      {humanReadableBoolean(roomCheck.chargeFromDeposit)}
    </Table.Cell>
    <Table.Cell className="description">
      <div className="textContainer">{roomCheck.description}</div>
    </Table.Cell>
    <Table.Cell className="status">
      <div>
        <StatusBox
          status={roomCheck.status}
          color={STATUS_TO_COLOR_MAPPER[roomCheck.status]}
        />
      </div>
    </Table.Cell>
  </Table.Row>
);

class DepartureRoomChecksTable extends React.Component<
  DepartureRoomChecksTableProps
> {
  render() {
    const {
      roomChecks,
      disableAddButton,
      openAddDepartureRoomCheckModal,
      openDepartureRoomCheckDetailModal,
      openInvoiceDetailModal
    } = this.props;

    return (
      <div className="DepartureRoomChecksTable">
        <Table className="DepartureRoomChecksTable__table">
          <Table.Header>
            <Table.HeaderItem heading="Room no" className="room" />
            <Table.HeaderItem heading="Room type" className="roomType" />
            <Table.HeaderItem heading="Inventory" className="inventory" />
            <Table.HeaderItem heading="Maintenance" className="maintenance" />
            <Table.HeaderItem heading="Images" className="images" />
            <Table.HeaderItem
              heading="Total charge"
              className="totalDamageCharge"
            />
            <Table.HeaderItem
              heading="Front Desk Charge"
              className="frontDeskCharge"
            />
            <Table.HeaderItem
              heading="Retained from deposit?"
              className="toBeRetainedFromDeposit"
            />
            <Table.HeaderItem heading="Description" className="description" />
            <Table.HeaderItem heading="Status" className="status" />
          </Table.Header>
        </Table>
        {_.isEmpty(roomChecks) && <EmptyListPlaceholder />}
        {!_.isEmpty(roomChecks) && (
          <Table>
            <Table.Body className="DepartureRoomChecksTable__tableBody">
              {roomChecks.map((roomCheck, index) => (
                <RoomCheckRow
                  key={index}
                  roomCheck={roomCheck}
                  openDepartureRoomCheckDetailModal={
                    openDepartureRoomCheckDetailModal
                  }
                  openInvoiceDetailModal={openInvoiceDetailModal}
                />
              ))}
            </Table.Body>
          </Table>
        )}
        <div className="DepartureRoomChecksTable__footer">
          <Button
            blue
            disabled={disableAddButton}
            onClick={openAddDepartureRoomCheckModal}>
            Add
          </Button>
        </div>
      </div>
    );
  }
}
export default DepartureRoomChecksTable;
